/* eslint-disable @typescript-eslint/no-unused-vars */
import { css, Theme, useTheme } from '@emotion/react'
import { ButtonHTMLAttributes, FC } from 'react'

type Props = {
  outline?: boolean
} & ButtonHTMLAttributes<HTMLButtonElement>

const Button: FC<Props> = ({ outline, children, ...rest }) => {
  const theme = useTheme()

  return (
    <button
      css={[buttonStyle(theme), outline && outlineButtonStyle()]}
      {...rest}
    >
      {children}
    </button>
  )
}

export default Button

const buttonStyle = (theme: Theme) => css`
  width: 100%;
  max-width: 400px;
  padding-block: 22px;
  border: 4px solid ${theme.color.yellow};
  border-radius: 40px;
  background-color: ${theme.color.yellow};
  color: ${theme.color.black};
  font-size: 18px;
  font-weight: bold;
  line-height: 1.5556;
  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);

  @media (max-width: 767px) {
    padding-block: 12px;
  }

  &:focus {
    box-shadow: 0 0 0 4px #daedf8, 0 0 0 6px ${theme.color.yellow};
  }

  &:hover {
    background-color: #1a1a1a;
    border-color: #1a1a1a;
    color: #fff;
  }
`

const outlineButtonStyle = () => css`
  color: #fff;
  background-color: transparent;
`
